






import Vue from "vue";
import TestLayout from "@/layouts/TestLayout.vue";
import Index from "@/pages/Index.vue";
import Parallax from "@/components/fx/Parallax.vue";

export default Vue.extend({
  name: "app",
  components: {
    TestLayout,
    Index
  }
});
